import MainLayout from '../layouts/main';
import Home from './home';

function HomePage() {
  return (
    <MainLayout
      loginRequired={false}
      consultPackageRequired={false}
      packageRequired={false}
    >
      <Home/>
    </MainLayout>
  );
}

export default HomePage;
